import type { FC } from "react";
import styled from "styled-components";

interface ToggleButtonProps {
  toggled: boolean;
  onToggle: (toggled: boolean) => void;
  height: number;
}

const ToggleButton: FC<ToggleButtonProps> = ({ toggled, onToggle, height }) => {
  return (
    <ToggleButtonWrapper
      $height={height}
      type="button"
      className={`${toggled ? "toggled" : ""}`}
      onClick={() => onToggle(!toggled)}
    >
      <div className="thumb"></div>
    </ToggleButtonWrapper>
  );
};

const ToggleButtonWrapper = styled.button<{ $height: number }>`
    --thumb-diameter: ${(p) => `${p.$height - 4}px`};
    --border-width: 1px;
    background-color: var(--button-bg-off) !important;
    border: var(--border-width) solid var(--button-bg-off) !important;

    border-radius: 99px !important;
    width: var(--button-width);
    max-width: var(--button-width);
    transition: background-color 0.1s ease, border-color 0.2s ease;
    cursor: pointer;
    position: relative;
    padding: 0 !important;
    height: ${(p) => `${p.$height + 2}px`};

    div.thumb
    {
        height: var(--thumb-diameter);
        width: var(--thumb-diameter);
        background-color: #fff;
        border-radius: 99px;
        transform: translateX(0);
        transition: left 0.15s ease;
        position: absolute;
        left: 2px;
        top: 50%;
        transform: translateY(-50%);
    }

    &.toggled
    {
        background-color: var(--button-bg-on) !important;
        border-color: var(--button-bg-on) !important;

        div.thumb
        {
            left: calc(var(--button-width) - var(--thumb-diameter) - 2*var(--border-width) - 2px)
        }
    }

    &:hover
    {
        border-color: #6f6f6f;
    }
`;

export default ToggleButton;
